const scrollPositions = {
  artistIndex: 0
};

export default scrollPositions;
